/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'
import { AnimatePresence, m } from 'motion/react'
import { type TabsLeftTabVideoPanelFieldsFragment } from 'types/dato'
import Video from 'components/materia/video'
import s from './style.module.css'

interface IVideoPanel extends TabsLeftTabVideoPanelFieldsFragment {
	isActive: boolean
}

const VideoPanel = ({ url, isActive }: IVideoPanel) => {
	return (
		<div className={s.root}>
			<AnimatePresence>
				{isActive ? (
					<m.div
						className={s.videoWrapper}
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						transition={{
							duration: 0.5,
						}}
					>
						<Video url={url} />
					</m.div>
				) : null}
			</AnimatePresence>
		</div>
	)
}

export default VideoPanel
